import { render, staticRenderFns } from "./t-emty-wrapper.vue?vue&type=template&id=f9b4d5e0&scoped=true&lang=pug&"
import script from "./t-emty-wrapper.vue?vue&type=script&lang=js&"
export * from "./t-emty-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./t-emty-wrapper.vue?vue&type=style&index=0&id=f9b4d5e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b4d5e0",
  null
  
)

export default component.exports